import type { Node } from '@xyflow/react';
import { ActionNodeData, MappedActionNode, MapperRegistryType } from './map-canvas-content.types';
import { NodeType } from '../hooks/use-sidebar-control.types';

export const ACTION_TYPE_MAPPER: Record<
  ActionNodeData['actionType'],
  (node: Node<ActionNodeData>) => MappedActionNode['rules']
> = {
  forwardToPartners: (node) => ({
    forwardToPartners: {
      partnerIds: node.data.partnerIds?.map((partner) => partner.value) ?? [],
    },
  }),
};

export const createCanvasMapperRegistry = (params: {
  mapEnrollNode: MapperRegistryType[NodeType.Enroll];
  mapWaitNode: MapperRegistryType[NodeType.Wait];
  mapActionNode: MapperRegistryType[NodeType.Action];
}): MapperRegistryType => {
  return {
    [NodeType.Enroll]: params.mapEnrollNode,
    [NodeType.Wait]: params.mapWaitNode,
    [NodeType.Action]: params.mapActionNode,
  };
};
